import React, { useEffect } from 'react';
import styled, { Interpolation } from 'styled-components';
import { SET_USER_PRIVATE_MONEY_HIGHLIGHTED } from '../../actions/user-private-money';
import { useAppDispatch, useAppSelector } from '../../hooks/useApp';
import { selectUserPrivateMoney, UserPrivateMoney } from '../../reducers/user-private-money';

type Props = {
  wrapperStyles?: Interpolation<React.CSSProperties>;
  labelTextStyles?: Interpolation<React.CSSProperties>;
  valueTextStyles?: Interpolation<React.CSSProperties>;
  highlightHeader?: boolean;
  allowedPrivateMoneys?: UserPrivateMoney[];
};

const Wrapper = styled.div<{
  styles?: Interpolation<React.CSSProperties>;
}>`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 6px 0;
  ${({ styles }) => styles}
`;

const LabelText = styled.span<{
  styles?: Interpolation<React.CSSProperties>;
}>`
  ${({ styles }) => styles}
`;

const ValueText = styled.span<{
  styles?: Interpolation<React.CSSProperties>;
}>`
  font-weight: bold;
  opacity: 0.8;
  ${({ styles }) => styles}
`;

const emptyArray: UserPrivateMoney[] = [];

const SelectedPrivateMoneyDisplay = ({
  wrapperStyles,
  labelTextStyles,
  valueTextStyles,
  highlightHeader = false,
  allowedPrivateMoneys = emptyArray,
}: Props) => {
  const userPrivateMoney = useAppSelector(selectUserPrivateMoney);
  const isHighlighted = useAppSelector((state) => state.userPrivateMoney.isHighlighted);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (highlightHeader && !isHighlighted) {
      dispatch(
        SET_USER_PRIVATE_MONEY_HIGHLIGHTED({
          isHighlighted: true,
          allowedMoneys: allowedPrivateMoneys,
        })
      );
    }
  }, [dispatch, highlightHeader, allowedPrivateMoneys, isHighlighted]);

  useEffect(() => {
    return () => {
      dispatch(
        SET_USER_PRIVATE_MONEY_HIGHLIGHTED({
          isHighlighted: false,
        })
      );
    };
  }, []);

  return (
    <Wrapper styles={wrapperStyles}>
      <LabelText styles={labelTextStyles}>マネー: </LabelText>
      <ValueText styles={valueTextStyles}>{userPrivateMoney.name}</ValueText>
    </Wrapper>
  );
};

export default SelectedPrivateMoneyDisplay;
